import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Home from "./pages/Home/Home";
import "./constant/Css.css";
import About from "./pages/about/About";
import Services from "./pages/services/Services";
import Contact from "./pages/contact/Contact";
import Accomodation from "./pages/accomodation/Accomodation";
import Scholarship from "./pages/scholarship/Scholarship";
import Resume from "./pages/resume/Resume";
import Sim from "./pages/sim/Sim";
import Visa from "./pages/visa/Visa";
import Air from "./pages/Air/Air";
import Resources from "./pages/Resources/Resources";
import Pricing from "./pages/pricing/Pricing";
import Checkout from "./pages/checkout/Checkout";
import Terms from "./pages/terms/Terms";
import Privacy from "./pages/privacy/Privacy";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/resources", element: <Resources /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/checkout", element: <Checkout /> },
  { path: "/contact", element: <Contact /> },
  { path: "/accomodation", element: <Accomodation /> },
  { path: "/scholarship", element: <Scholarship /> },
  { path: "/resume", element: <Resume /> },
  { path: "/sim", element: <Sim /> },
  { path: "/visa", element: <Visa /> },
  { path: "/air", element: <Air /> },
  { path: "/terms", element: <Terms /> },
  { path: "/privacy", element: <Privacy /> },
]);

function App() {
  return (
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  );
}

export default App;
